import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CategoriesColumnsService, CompetitionsDataService , CompetitionsColumnsService} from '../../../services';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
// import { Column } from 'jspdf-autotable';
import { Competition } from '../../../interfaces';
import { ToolsService } from '../../../../services/tools/tools.service';
import { Column } from '../../../interfaces/column.interface';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-competition-classement',
  templateUrl: './competition-classement.component.html',
  styleUrls: ['./competition-classement.component.scss']
})
export class CompetitionClassementComponent implements OnInit {

  public competition: Competition = {};
  public filteredAndSortedReports:any;
  public columns: Column[] = [];
  private _selectedColumns: Column[] = [];

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private messageService: MessageService,
    private competitionsDataService: CompetitionsDataService,
    private competitionsColumnsService: CompetitionsColumnsService
  ) { }

  ngOnInit(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.competition !== 'undefined') {
      this.competition = this.dynamicDialogConfig.data.competition;
      this.competitionsDataService.getCompetitionClassement(this.competition.id).subscribe((res: any) => {
        this.messageService.clear();
        console.log(res.success)
        this.filteredAndSortedReports = res.success;
        this.setColumns();

      }, (error: any) => {
        this.messageService.clear();
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'error to get classment'});
      });
    }
   
  }
  exportToExcel(): void {
    const worksheet = XLSX.utils.json_to_sheet(this.filteredAndSortedReports);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Classement');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const start = this.competition?.startDate || 'début';
    const end = this.competition?.endDate || 'fin';

    saveAs(data, `Classement_${start}_${end}.xlsx`);
  }
  
  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.competitionsColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }
}

@Component({
  selector: 'app-competition-classement',
  templateUrl: './competition-classement.component.html',
  styleUrls: ['./competition-classement.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCompetitionClassementComponent extends CompetitionClassementComponent {}

